/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { all, put, takeEvery } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { addSystemErrorMessage } from '../actions';
import { HTML_INCLUDE_LOAD, loadHtmlInclude, LOAD_STATIC_HTML_FRAGMENTS, setHtmlInclude } from './actions';

function* htmlInludeLoadGenerator(action: Action<string>) {
    let url = action.payload;
    // TODO wrap with fetchWrapperFunc (?)
    try {
        let content: Response = yield fetch(url);
        let text: string = yield content.text();
        yield put(
            setHtmlInclude({
                url: url,
                content: text
            })
        );
    } catch (err) {
        if (err instanceof Response) {
            yield put(addSystemErrorMessage(err.toString()));
        }
    }
}

function* loadStaticHtmlFragmentsGenerator() {
    yield put(
        loadHtmlInclude('https://static2.funtip.de/static-layout/radioeins/footer.module.head.externalize.true.html')
    );
    yield put(
        loadHtmlInclude(
            'https://static2.funtip.de/static-layout/radioeins/footer.module.ft_header.externalize.true.html'
        )
    );
}

function* htmlInludeActionWatch() {
    yield takeEvery(HTML_INCLUDE_LOAD, htmlInludeLoadGenerator);
    yield takeEvery(LOAD_STATIC_HTML_FRAGMENTS, loadStaticHtmlFragmentsGenerator);
}

export function* htmlIncludeSagas() {
    yield all([htmlInludeActionWatch()]);
}
